import { createAsyncThunk } from '@reduxjs/toolkit'
import { Api, ApiMethod } from '../../../../utils/Api'
import { FlowType, InterviewFlow } from '../interface'
import { InterviewNode } from '../../../../CandidatePortal/scenes/Interview/Chatbot/interface'
import URI from 'urijs'
import { processParams } from '../../../../utils/LazyParamsUtil'

const interviewFlowEndpoint = process.env.REACT_APP_INTERVIEW_API_URL

export const getInterviewFlow =
  createAsyncThunk('interviewFlow/getInterviewFlow',
    async ({ id, typeOfId }: { id: number | string, typeOfId: string }, { rejectWithValue }) =>
      Api(ApiMethod.GET, interviewFlowEndpoint, 'getInterviewFlowBy' + typeOfId + '/' + id, {}, rejectWithValue)
  )

export const createAndSaveInterviewFlow =
  createAsyncThunk('interviewFlow/createInterviewFlow/',
    async (interviewFlow: InterviewFlow, { rejectWithValue }) =>
      Api(ApiMethod.POST,
        interviewFlowEndpoint, 'createInterviewFlow', interviewFlow, rejectWithValue)
  )

export const updateInterviewFlow =
  createAsyncThunk('interviewFlow/updateInterviewFlow',
    async (interviewFlow: InterviewFlow, { rejectWithValue }) =>
      Api(ApiMethod.PUT,
        interviewFlowEndpoint,
        interviewFlow.interviewFlowEnum === FlowType.GLOBAL ?
          "updateInterviewFlowTemplate" : "updateInterviewFlow",
        interviewFlow, rejectWithValue)
  )

export const getInterviewNodesByFlow =
  createAsyncThunk('interviewFlow/getInterviewNodesFor/',
    async (interviewFlowId: number, { rejectWithValue }) =>
      Api(ApiMethod.GET,
        interviewFlowEndpoint, 'getInterviewNodesFor/' + interviewFlowId, {}, rejectWithValue)
  )

export const getExistingFlowsForTenant =
  createAsyncThunk('interviewFlow/getExistingFlowsForTenant',
    async (interviewFlowId: number, { rejectWithValue }) =>
      Api(ApiMethod.GET,
        interviewFlowEndpoint, 'getExistingFlowsForTenant/' + interviewFlowId, {}, rejectWithValue)
  )

export const getInterviewFlowGlobalTemplateListing =
  createAsyncThunk('interviewFlow/getInterviewFlowGlobalTemplateListing',
    async ({ lazyParams, interviewFlowId } : {lazyParams: any, interviewFlowId: number}, 
            { rejectWithValue }) =>
      Api(ApiMethod.GET,
        interviewFlowEndpoint, 'getInterviewFlowGlobalTemplateListing/' + interviewFlowId,
        processParams(lazyParams), rejectWithValue)
  )

  export const generateInterviewFlow = createAsyncThunk('interview/generateInterviewFlow',
    async ({interviewFlowId, jobTitle, jobDescription, numberOfQuestion}: 
      {interviewFlowId: number, jobTitle: string, jobDescription: string, numberOfQuestion: number}, { rejectWithValue }) => 
      Api(ApiMethod.POST, interviewFlowEndpoint, `generateInterviewFlow/${interviewFlowId}`, {jobTitle, jobDescription, numberOfQuestion}, rejectWithValue)
  )
  
  export const generateInterviewFlowByJob = createAsyncThunk('interview/generateInterviewFlowByJob',
    async ({interviewFlowId, numberOfQuestion}: {interviewFlowId: number, numberOfQuestion: number}, { rejectWithValue }) => 
      Api(ApiMethod.POST, interviewFlowEndpoint, `generateInterviewFlowByJob/${interviewFlowId}`, {numberOfQuestion}, rejectWithValue)
  )
